import {all, fork, put} from 'redux-saga/effects';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import { takeEvery, call } from '../../shared/SagaService';

// Create tag group
export function* createTagGroupRequest() {
    yield takeEvery(actions.CREATE_TAG_GROUP_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/tags/groups', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_TAG_GROUP_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_TAG_GROUP_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createTagGroupSuccess() {
    yield takeEvery(actions.CREATE_TAG_GROUP_SUCCESS, function* () {
        yield message.success(t`The tag group is created.`);
    });
}
export function* createTagGroupError() {
    yield takeEvery(actions.CREATE_TAG_GROUP_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read tag groups
export function* readTagGroupsRequest() {
    yield takeEvery(actions.READ_TAG_GROUPS_REQUEST, function* ({ request}, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/tags/groups', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_TAG_GROUPS_SUCCESS,
                tagGroups: data.tag_groups,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_TAG_GROUPS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readTagGroupsSuccess() {
    yield takeEvery(actions.READ_TAG_GROUPS_SUCCESS, () => {});
}
export function* readTagGroupsError() {
    yield takeEvery(actions.READ_TAG_GROUPS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read tag group
export function* readTagGroupRequest() {
    yield takeEvery(actions.READ_TAG_GROUP_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/tags/groups/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_TAG_GROUP_SUCCESS,
                tagGroup: data.tag_group,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_TAG_GROUP_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readTagGroupSuccess() {
    yield takeEvery(actions.READ_TAG_GROUP_SUCCESS, () => {});
}
export function* readTagGroupError() {
    yield takeEvery(actions.READ_TAG_GROUP_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update tag group
export function* updateTagGroupRequest() {
    yield takeEvery(actions.UPDATE_TAG_GROUP_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/tags/groups/${id}`, request, context);

            // OK
            yield put({
                type: actions.UPDATE_TAG_GROUP_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_TAG_GROUP_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateTagGroupSuccess() {
    yield takeEvery(actions.UPDATE_TAG_GROUP_SUCCESS, function* () {
        yield message.success(t`The tag group is updated.`);
    });
}
export function* updateTagGroupError() {
    yield takeEvery(actions.UPDATE_TAG_GROUP_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete tag group
export function* deleteTagGroupRequest() {
    yield takeEvery(actions.DELETE_TAG_GROUP_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/tags/groups/${id}`, null, context);

            // OK
            yield put({
                type: actions.DELETE_TAG_GROUP_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_TAG_GROUP_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteTagGroupSuccess() {
    yield takeEvery(actions.DELETE_TAG_GROUP_SUCCESS, function* () {
        yield message.success(t`The tag group is deleted / archived.`);
    });
}
export function* deleteTagGroupError() {
    yield takeEvery(actions.DELETE_TAG_GROUP_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Activate tag group
export function* activateTagGroupRequest() {
    yield takeEvery(actions.ACTIVATE_TAG_GROUP_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/tags/groups/${id}/activate`, null, context);

            // OK
            yield put({
                type: actions.ACTIVATE_TAG_GROUP_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACTIVATE_TAG_GROUP_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* activateTagGroupSuccess() {
    yield takeEvery(actions.ACTIVATE_TAG_GROUP_SUCCESS, function* () {
        yield message.success(t`The tag group is activated.`);
    });
}
export function* activateTagGroupError() {
    yield takeEvery(actions.ACTIVATE_TAG_GROUP_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Create tag
export function* createTagRequest() {
    yield takeEvery(actions.CREATE_TAG_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/tags', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_TAG_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_TAG_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createTagSuccess() {
    yield takeEvery(actions.CREATE_TAG_SUCCESS, function* () {
        yield message.success(t`The tag is created.`);
    });
}
export function* createTagError() {
    yield takeEvery(actions.CREATE_TAG_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read tag
export function* readTagRequest() {
    yield takeEvery(actions.READ_TAG_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/tags/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_TAG_SUCCESS,
                tag: data.tag,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_TAG_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readTagSuccess() {
    yield takeEvery(actions.READ_TAG_SUCCESS, () => {});
}
export function* readTagError() {
    yield takeEvery(actions.READ_TAG_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update tag
export function* updateTagRequest() {
    yield takeEvery(actions.UPDATE_TAG_REQUEST, function* ({ id, request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/tags/${id}`, request, context);

            // OK
            yield put({
                type: actions.UPDATE_TAG_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_TAG_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateTagSuccess() {
    yield takeEvery(actions.UPDATE_TAG_SUCCESS, function* () {
        yield message.success(t`The tag is updated.`);
    });
}
export function* updateTagError() {
    yield takeEvery(actions.UPDATE_TAG_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete tag
export function* deleteTagRequest() {
    yield takeEvery(actions.DELETE_TAG_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/tags/${id}`, null, context);

            // OK
            yield put({
                type: actions.DELETE_TAG_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_TAG_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteTagSuccess() {
    yield takeEvery(actions.DELETE_TAG_SUCCESS, function* () {
        yield message.success(t`The tag is deleted / archived.`);
    });
}
export function* deleteTagError() {
    yield takeEvery(actions.DELETE_TAG_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Activate tag
export function* activateTagRequest() {
    yield takeEvery(actions.ACTIVATE_TAG_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, `/tags/${id}/activate`, null, context);

            // OK
            yield put({
                type: actions.ACTIVATE_TAG_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.ACTIVATE_TAG_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* activateTagSuccess() {
    yield takeEvery(actions.ACTIVATE_TAG_SUCCESS, function* () {
        yield message.success(t`The tag is activated.`);
    });
}
export function* activateTagError() {
    yield takeEvery(actions.ACTIVATE_TAG_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createTagGroupRequest),
        fork(createTagGroupSuccess),
        fork(createTagGroupError),
        fork(readTagGroupsRequest),
        fork(readTagGroupsSuccess),
        fork(readTagGroupsError),
        fork(readTagGroupRequest),
        fork(readTagGroupSuccess),
        fork(readTagGroupError),
        fork(updateTagGroupRequest),
        fork(updateTagGroupSuccess),
        fork(updateTagGroupError),
        fork(deleteTagGroupRequest),
        fork(deleteTagGroupSuccess),
        fork(deleteTagGroupError),
        fork(activateTagGroupRequest),
        fork(activateTagGroupSuccess),
        fork(activateTagGroupError),
        fork(createTagRequest),
        fork(createTagSuccess),
        fork(createTagError),
        fork(readTagRequest),
        fork(readTagSuccess),
        fork(readTagError),
        fork(updateTagRequest),
        fork(updateTagSuccess),
        fork(updateTagError),
        fork(deleteTagRequest),
        fork(deleteTagSuccess),
        fork(deleteTagError),
        fork(activateTagRequest),
        fork(activateTagSuccess),
        fork(activateTagError),
    ]);
}
